export { default } from './FluentLogo';
